'use client';

import Image from 'next/image';

const aiEngineering = [
    {
        icon: 'global.png',
        title: 'Global Delivery Experience',
        desc: '18+ years of delivering web, mobile, cloud, AI, and enterprise software solutions across global markets. Offices in Ahmedabad, India and Secaucus, New Jersey with onshore-offshore delivery flexibility.',
    },
    {
        icon: 'security.png',
        title: 'Security and Process Maturity',
        desc: 'ISO 27001:2022 certified and CMMI Level 3 compliant. Our delivery practices meet the security, documentation, and process standards that enterprise buyers expect and audit teams require.',
    },
    {
        icon: 'ai-first.png',
        title: 'AI-First Engineering Capability',
        desc: 'From AI strategy and LLM application development to workflow automation, agentic AI, data engineering, and production deployment. We build AI that operates reliably inside real enterprise systems.',
    },
    {
        icon: 'proven.png',
        title: 'Proven Execution Track Record',
        desc: '900+ projects delivered across startups, SMEs, and enterprise clients in more than 20 industries including FinTech, Healthcare, Logistics, Real Estate, Hospitality, and Manufacturing.',
    },
];

const UsaAiEngineering = () => {
    return (
        <section className="section-py relative overflow-hidden bg-primary_one">
            <div className="container lg:container md:mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12 text-center">
                        <div className="mb-4 gradient-border">
                            <span className="gradient-text">Why the USA Businesses Choose Moweb</span>
                        </div>
                        <h2 className="text-primary text-center mb-4">
                            AI Engineering Experience Backed by Enterprise-Grade Process <div> and Security Maturity</div>
                        </h2>
                        <div className="text-center mb-0 fs-md fw-700 text-white">
                            Moweb combines 18+ years of global software engineering experience with AI-first delivery practices,
                            certified Security
                            <div>
                                {' '}
                                standards, and the process discipline that enterprise and mid-market organizations require.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row grid sm:grid-cols-1 lg:grid-cols-4 gap-3">
                    {aiEngineering.map((item, index) => (
                        <div key={index} className="card rounded-10 glass-effect-aiml p-6 flex flex-col gap-4">
                            <div className="flex items-center gap-3">
                                <Image src={`/img/lets-meet-usa/${item.icon}`} alt={item.title} width={32} height={32} />
                            </div>
                            <h3 className="fs-md fw-700 text-primary mb-0">{item.title}</h3>
                            <p className="mb-0 fs-md fw-400 text-white">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default UsaAiEngineering;
